export default __webpack_public_path__ + "static/media/img2.eb28404c.jpg";